// extracted by mini-css-extract-plugin
export default {"baseBtn":"EnableButton_baseBtn__zqRWw","isActive":"EnableButton_isActive__8uzAy"};